


import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { SuccessErrorConst } from '../../config/successErrorConst';
const messageService = () => {
  const message = SuccessErrorConst;

  /******************* toast messages ********************/
  const toast = (type: any, title: any) => {
    const Toast = withReactContent(Swal.mixin({
      toast: true,
      position: 'top', // Set to 'top' (not 'center')
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast: HTMLElement) => {
        // Manually center the toast
        toast.style.margin = 'auto';
        toast.style.left = '50%';
        toast.style.transform = 'translateX(-50%)';
        toast.style.position = 'fixed'; // Make sure it's fixed
        toast.style.top = '1rem'; // Adjust top padding as needed
      // Ensure width fits content
      toast.style.width = 'auto';
      toast.style.maxWidth = '90%'; // Optional: Prevent it from being too wide on small screens
      toast.style.whiteSpace = 'nowrap'; // Optional: Keep text on one line
  
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    }));

    Toast.fire({
      icon: type,
      title: title
    });
  };

  /******************* confirmation dialog box (returns a promise) ********************/
  const confirm = async (title: any, text: any) => {
    return await Swal.fire({
      text: text,
      icon: 'warning',
      showCancelButton: true,
      title: `Are you sure you want to ${title}?`,
      showConfirmButton: true
    });
  };

  /******************* alert dialog box with button ********************/
  const alert = (type: any, title: any, text: any) => {
    Swal.fire(title, text, type);
  };

  return {
    message,
    toast,
    confirm,
    alert
  };
};

export default messageService;
